import axios from 'axios'
import { Notify } from 'vant'
import store from '@/store'
import router from '@/router'
import { auth } from '@bestvike/utils'
import { autoLogin } from '@/api/authority'

// create an axios instance
const instance = axios.create({
  baseURL: process.env.VUE_APP_MOCK === 'true' ? '' : process.env.VUE_APP_ROOT + (process.env.VUE_APP_BASE_API === '/' ? '' : process.env.VUE_APP_BASE_API),
  // withCredentials: true, // 跨域请求时发送 cookies
  isRetryRequest: false,
  timeout: 50000 // request timeout
})

instance.upload = (url, file, data) => {
  let formData = new FormData();
  // formData.append('file', file)
  if (file) {
    file.forEach((value) => {
      formData.append('file', value);
    });
  }
  if (data) {
    // data.forEach((value, key) => {
    //   formData.append(key, value)
    // })
    Object.keys(data).forEach(function(key){
      formData.append(key, data[key]);
    });
  }
  console.log(formData)
  return instance({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}



// request interceptor
instance.interceptors.request.use(
  config => {
    switch (config.method) {
      case 'get': {
        // get方法加一个时间参数,解决ie下可能缓存问题.
        if (!config.params) {
          config.params = {}
        } else {
          config.params = {...config.params}
        }
        if (!config.params.t) {
          config.params.t = new Date().getTime()
        }
        break
      }
      case 'post': {
        if (!config.headers['Content-Type']) {
          config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        }
        break
      }
      case 'put': {
        if (!config.headers['Content-Type']) {
          config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        }
        break
      }
    }
    // Do something before request is sent
    if (store.getters.token) {
      const token = auth.getToken()
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['X-Token'] = token
      if (!config.ignoreToken) {
        config.headers['Authorization'] = 'Bearer ' + token
      }
    }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

const isRefreshTokenReq = () => {
  return false
}
const isLogin = () => {
  return router.currentRoute.path === '/login'
}
const toLogin = () => {
  router.replace(`/login?redirect=${router.currentRoute.fullPath}`)
}
// const refreshAccessToken = () => {
//   if (!store.getters.refreshPromise) {
//     const refreshToken = auth.getRefreshToken()
//     store.dispatch('user/setRefreshPromise', new Promise((resolve, reject) => {
//       refresh(refreshToken).then(res => {
//         store.dispatch('user/resetToken', res.data)
//         resolve(res)
//       }).catch(error => {
//         reject(error)
//       })
//     }))
//   }
//   return store.getters.refreshPromise
// }

// response interceptor
instance.interceptors.response.use(
  response => response,
  error => {
    // 判断401错误，重新获取token
    switch (error.response.status) {
      case 401: {
        // 先清空token
        store.dispatch('user/resetToken')
        let config = error.config
        if (isLogin()) {
          Notify({
            message: error.response.data.message,
            duration: 5 * 1000
          })
          return Promise.reject(error)
        } else if (isRefreshTokenReq(config.url)) {
          // 刷新Token的请求如果出现401直接退出登录
          toLogin()
        } else {
          //console.log('请求的返回值出现401，由请求' + config.url + '的返回值触发，开始进行refresh_token！')
          try {
            let weixinId = store.state.user.weixinId;
            return autoLogin(weixinId).then(res => {
              if (res!=null&&res.data!=null){
                config.headers['X-Token'] = res.data.token;
                config.headers['Authorization'] = 'Bearer ' + res.data.token;
              }
              // store.dispatch('user/setRefreshPromise', '');
              // config.baseURL = '';
              return axios(config)
            }).catch (() => {
              toLogin()
            })
          } catch (error) {
            console.log('无法等待刷新Token！', error)
            toLogin()
          }
        }
        break
      }
      default: {
        Notify({
          message: error.response.data.message,
          duration: 5 * 1000
        })
        return Promise.reject(error)
      }
    }
  }
)


instance.download = (url, data) => {
  return instance({
    url: url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: JSON.stringify(data),
    responseType: 'arraybuffer'
  })
}

export default instance
